/* app/js/src/components/calendar/replace-show/replace-show-modal.component.scss */
.cursor-pointer {
  cursor: pointer;
}
input[type=text] {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
input[type=text]:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
input[type=text]::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input[type=text]:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input[type=text]::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input[type=text]:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input.ng-invalid.ng-dirty[type=text],
input.ng-invalid.ng-touched[type=text] {
  border-color: #ef5350;
}
.btn-cancel,
.btn-replace {
  display: inline-block;
  color: #ffffff;
  border-radius: 4px;
  background-color: #232f3a;
  padding: 6px 9px 6px 9px;
  font-size: 0.85em;
  border: 1px solid #879baf;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.btn-cancel:focus,
.btn-replace:focus {
  outline-color: #ffffff;
}
.btn-cancel:hover,
.btn-replace:hover {
  background-color: white;
  color: #232f3a;
}
.disabled.btn-cancel,
.disabled.btn-replace {
  color: #879baf;
  background-color: #dde3e7;
  border-color: #dde3e7;
  cursor: auto;
}
:host {
  display: flex;
  flex-direction: column;
  padding: 20px;
}
.title {
  font-family: "Open Sans";
  font-size: 20px;
  color: #232f3a;
  margin-bottom: 15px;
}
.new-media-id {
  font-family: "Open Sans";
  font-size: 12px;
  line-height: 30px;
  color: #93a9bf;
}
input[type=text] {
  width: 150px;
  height: 26px;
  border-radius: 4px;
  vertical-align: middle;
  margin-left: 7px;
  margin-right: 7px;
}
.checkbox-input {
  background-color: #ffffff;
  position: relative;
  line-height: 30px;
  display: flex;
  width: auto;
  margin: 0;
  margin-right: 10px;
}
.checkbox-input div {
  position: relative;
  border: 1px solid #e1e6eb;
  width: 14px;
  height: 14px;
  cursor: pointer;
  margin-top: 6px;
}
.checkbox-input div svg {
  width: 10px;
  height: 7px;
  position: absolute;
  top: -1px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  fill-opacity: 0;
}
.checkbox-input.active div svg {
  fill-opacity: 1;
}
.label-apply-all {
  line-height: 24px;
  font-size: 12px;
  font-family: "Open Sans";
}
.media-input-container {
  display: flex;
  margin-bottom: 15px;
}
.until-container {
  position: relative;
  font-size: 12px;
  font-family: "Open Sans";
  color: #232f3a;
  margin-bottom: 150px;
}
.until-container ::ng-deep .date-picker {
  top: -80px;
  left: 80px;
}
dateinput {
  width: 225px;
  margin-bottom: 15px;
}
.btn-replace {
  width: 65px;
  margin-left: 15px;
  text-align: center;
}
.btn-cancel {
  width: 65px;
  color: #232f3a;
  background-color: #879baf;
  text-align: center;
}
.apply-cancel-container {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
/*# sourceMappingURL=replace-show-modal.component.css.map */
